import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account/account.service';
import { LanguageService } from 'src/app/services/account/language.service';
import { AccountDialogComponent } from '../../account-dialog/account-dialog.component';
import { StackedModalsService } from 'src/app/services/modal/stacked-modals.service';
import { SubscriptionsDialogComponent } from '../subscriptions-dialog.component';

@Component({
  standalone: true,
  selector: 'app-subscription-required-dialog',
  templateUrl: './subscription-required-dialog.component.html',
  styleUrl: './subscription-required-dialog.component.scss'
})
export class SubscriptionRequiredDialogComponent {

  public featureInfo: string;

  constructor(public dialogRef: MatDialogRef<SubscriptionRequiredDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    public languageService: LanguageService, public accountService: AccountService, private readonly stackedModalsService: StackedModalsService) {

    let featureString = "";

    if (this.data.feature == "route-planning") {
      featureString = this.languageService.languageJSON.SubscriptionsDialog_RoutePlanning500km_ShortDescription;
    }

    if (this.data.feature == "voice-input") {
      featureString = this.languageService.languageJSON.SubscriptionsDialog_VoiceInput_ShortDescription;
    }

    this.featureInfo = this.languageService.languageJSON.SubscriptionsDialog_FeatureIsPartOfThePROAndPROPackage.replace("$feature", featureString);
  }

  public register(): void {
    this.stackedModalsService.openModal(AccountDialogComponent, {
      data: { process: "register" },
      panelClass: 'dialog-snap-to-fullscreen', autoFocus: false
    });
    this.dialogRef.close();
  }

  public activate(): void {
    this.stackedModalsService.openModal(SubscriptionsDialogComponent, {
      data: { process: 'signIn' },
      panelClass: 'dialog-snap-to-fullscreen', autoFocus: false
    });
    this.dialogRef.close();
  }

  public login(): void {
    this.stackedModalsService.openModal(AccountDialogComponent, {
      data: { process: 'signIn' },
      panelClass: 'dialog-snap-to-fullscreen', autoFocus: false
    });
    this.dialogRef.close();
  }

  public close(): void {
    this.dialogRef.close();
  }
}
